export function selectLegalEntity(entities = [], requestedId = '') {
  const requested = entities.find((entity) => entity.id === requestedId) || null;
  if (requested) return requested;
  return entities.length === 1 ? entities[0] : null;
}

export function belongsToLegalEntity(item, selectedId, entityCount) {
  if (!selectedId) return true;
  if (item?.legal_entity_id) return item.legal_entity_id === selectedId;
  return Number(entityCount) <= 1;
}

export function scopeItemsToLegalEntity(items = [], selectedId = '', entityCount = 0) {
  return items.filter((item) => belongsToLegalEntity(item, selectedId, entityCount));
}

export function selectBillingAddress(dashboard, selectedId = '', stripeSubscriptionId = '') {
  const entities = dashboard?.legal_entities || [];
  const selected = selectLegalEntity(entities, selectedId);
  if (entities.length > 1 && !selected) return null;
  const rows = dashboard?.billing_addresses || [];
  const scopedRows = selected ? rows.filter(row => row.legal_entity_id === selected.id) : [];
  const scoped = stripeSubscriptionId
    ? scopedRows.find(row => row.stripe_subscription_id === stripeSubscriptionId) || null
    : scopedRows.find(row => !row.stripe_subscription_id) || (scopedRows.length === 1 ? scopedRows[0] : null);
  if (scoped) return scoped;
  // A customer-wide fallback is safe only while there is a single company.
  return entities.length <= 1 ? dashboard?.billing_address || null : null;
}
